// extracted by mini-css-extract-plugin
export var container = "TimeLinePanelVertical-module--container--aefec";
export var headline = "TimeLinePanelVertical-module--headline--f2b70";
export var timeLineContainer = "TimeLinePanelVertical-module--timeLineContainer--2fd92";
export var timeLineVert = "TimeLinePanelVertical-module--timeLineVert--76dfa";
export var time_blok = "TimeLinePanelVertical-module--time_blok--7c27d";
export var time_content = "TimeLinePanelVertical-module--time_content--537a0";